import Vue from 'vue'
import { ToastPlugin, ModalPlugin, BButton, BModal } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueSocketIO from 'vue-socket.io'
import Vue2Filters from 'vue2-filters'
import VueCookies from 'vue-cookies'
import axios from 'axios'

import router from './router'
import store from './store'
import App from './App.vue'

import mDatePicker from 'vue-multi-date-picker'
import DisableAutocomplete from 'vue-disable-autocomplete'

import '@/libs/acl'
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'

// Maps / UI
import VueGoogleMap from 'vuejs-google-maps'
import 'vuejs-google-maps/dist/vuejs-google-maps.css'

import VueTimeago from 'vue-timeago'
import * as VueGoogleMaps from 'vue2-google-maps'

import Verte from 'verte'
import 'verte/dist/verte.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/de'

import { socket } from '@/libs/socket' // ✅ unser echter socket.io-client

// ===== Helpers =====
function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return ''
}

// ===== Vue Plugins =====
Vue.use(ElementUI, { locale })

Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'de',
  locales: {
    de: require('date-fns/locale/de'),
  },
})

Vue.use(mDatePicker)
Vue.use(DisableAutocomplete)

Vue.component('b-button', BButton)
Vue.component('b-modal', BModal)

Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueCompositionAPI)
Vue.use(VueCookies)

// register component globally
Vue.use(Verte.name, Verte)

// ===== Maps =====
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDMxgirQFfpQUdTYoLeiu84abtyW6U5GXw',
    libraries: 'places',
  },
})

Vue.use(VueGoogleMap, {
  load: {
    apiKey: 'AIzaSyDMxgirQFfpQUdTYoLeiu84abtyW6U5GXw',
    libraries: [],
  },
})

// ===== Styles =====
require('@core/scss/core.scss')
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// ===== Socket.IO (✅ Safari friendly) =====
Vue.use(new VueSocketIO({
  debug: true,
  reconnect: true,
  connection: socket, // ✅ wichtig: echtes socket.io-client Objekt
}))

// ===== Axios =====
const axiosIns = axios.create({
  baseURL: window.location.host === 'localhost:8080'
      ? 'https://localhost:5001/'
      : 'https://api.flughafentransfer.com/',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    jwt: getCookie('jwt'),
  },
})

Vue.prototype.$http = axiosIns

// ===== Filters =====
const Vue2FiltersConfig = {
  capitalize: { onlyFirstLetter: false },
  number: { format: '0', thousandsSeparator: ',', decimalSeparator: '.' },
  bytes: { decimalDigits: 2 },
  percent: { decimalDigits: 2, multiplier: 100, decimalSeparator: '.' },
  currency: {
    symbol: '€',
    decimalDigits: 2,
    thousandsSeparator: '.',
    decimalSeparator: ',',
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: false,
    showPlusSign: false,
  },
  pluralize: { includeNumber: false },
  ordinal: { includeNumber: false },
}
Vue.use(Vue2Filters, Vue2FiltersConfig)

// ===== App =====
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
